import { defineComponent as _defineComponent } from 'vue'
import { LogService } from "@/services";
import { computed, onMounted, ref } from "vue";
import { useViewAnalytics } from "@/composition/useViewAnalytics";
import { useAppStore } from "@/pinia/app";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginRedirect',
  setup(__props) {

const pageName = ref("Login");
const { pageTitle } = useViewAnalytics(pageName);

const appStore = useAppStore();

const route = useRoute();

const loginUrl = computed(() => {
  return appStore.djangoSiteOrigin + "/login/?next=" + route.query.next;
});

onMounted(() => {
  LogService.info(`Redirecting to '${loginUrl.value}'`);
  window.location.href = loginUrl.value;
});

return { __sfc: true,pageName, pageTitle, appStore, route, loginUrl }
}

})